import type { TrackingDriver } from '@/tracking/contracts/TrackingDriver'
import { inject } from 'vue'
import { TRACKING_PLUGIN_INJECT_KEY } from '@/plugins/TrackingPlugin'

export const useTracking = (): TrackingDriver => {
  const driver = inject<TrackingDriver>(TRACKING_PLUGIN_INJECT_KEY)

  if (!driver) {
    throw new Error('Could not load driver')
  }

  return driver
}
